import React from "react";
import { Chip } from "@mui/material";

const Tag = (props) => {
  const { backgroundColor, color, label } = props;
  return (
    <Chip
      label={label}
      size="small"
      className="heading-xs"
      sx={{
        height: "18px",
        backgroundColor: backgroundColor,
        "& .MuiChip-label": {
          lineHeight: "1",
          fontWeight: "500",
          fontFamily: "Work Sans",
          color: `${color} !important`,
        },
      }}
    />
  );
};

export default Tag;
